export default {
  OBTENER_NOTIFICACIONES_USUARIO: 'OBTENER_NOTIFICACIONES_USUARIO',
  OBTENER_NOTIFICACIONES_USUARIO_SUCCESS: 'OBTENER_NOTIFICACIONES_USUARIO_SUCCESS',
  MARCAR_COMO_LEIDO_NOTIFICACION: 'MARCAR_COMO_LEIDO_NOTIFICACION',
  MARCAR_COMO_LEIDO_NOTIFICACION_STOCK: 'MARCAR_COMO_LEIDO_NOTIFICACION_STOCK'
}